import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import permissions from "../../mocks/menuPermissions.json";
import { camelCase } from "lodash";
import authService from "../api-authorization/AuthorizeService";
const AddCompanyItemsLayout = ({
  content,
  buttonLabel,
  link,
  className,
  disabled,
  showError,
  errorMessage,
  onPrimaryClick,
  subMenu,
}) => {
  var isAllowed;
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  isAllowed = subMenu
    ? permissions[roleName]["companySubMenu"][camelCase(subMenu)].includes(
        "C"
      ) ||
      permissions[roleName]["companySubMenu"][camelCase(subMenu)].includes("U")
    : permissions[roleName]["menuItems"]["company"].includes("C");

  return (
    <div
      className={`add-module-items d-flex align-items-center justify-content-start h-75 bg-white ${className} add-items`}
    >
      <div className="p-5">
        <h4 className="mb-3">{content}</h4>
        {!link && isAllowed && (
          <Button type="button" disabled={disabled} onClick={onPrimaryClick}>
            {buttonLabel}
          </Button>
        )}
        {link && isAllowed && (
          <Link to={link} disabled={disabled}>
            <Button type="button" disabled={disabled} onClick={onPrimaryClick}>
              {buttonLabel}
            </Button>
          </Link>
        )}
        {showError && (
          <div className="invalid-feedback d-block">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default AddCompanyItemsLayout;
